import FontFaceObserver from 'fontfaceobserver'
export default () => {
  const ubuntu = new FontFaceObserver('Ubuntu')
  const openSans = new FontFaceObserver('Open Sans')
  Promise.all([ubuntu.load(), openSans.load()]).then(() => {
    if (!document.documentElement.classList.contains('fonts-loaded')) {
      document.documentElement.classList.add('fonts-loaded')
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/ObserveFontFace.js